<div class="google-search-assembly container">
  <mtn-map-toolbar-button icon="search-location" matTooltip="Search" (toolbarClick)="openGoogleSearchWizard()"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.OPEN_WIZARD"
                          [analyticsEventParameters]="{'target': 'google-search'}"
                          *ngIf="map.options.controlConfiguration.isGoogleSearchEnabled"></mtn-map-toolbar-button>
</div>
